// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5606":"css/app.6944","9894":"css/admin-app.6944"}[chunkId] + ".css";
};